import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'enter-code',
	template: require('./enter-code.component.html'),
	styles: [require('./enter-code.component.scss')]
})
export class EnterCodeComponent {
	@Input() verificationCode: string;
	@Output() codeEnter: EventEmitter<string> = new EventEmitter();

	onCodeType(event): void {
		this.codeEnter.emit(event.target.value);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/2fa/modals/two-fa-setup-modal/enter-code/enter-code.component.ts